export const interpolatePathParams = (url: string, valuesObject: Record<string, string>) => {
  const matches = url.match(/:\w+\??/g);

  if (!matches) return url;

  let interpolatedUrl = matches?.reduce((acc: string, match: string) => {
    const key = match.slice(1).replace(/\?$/, '');
    const value = valuesObject[key];
    const isValueUndefined = typeof value === 'undefined';

    if (match.endsWith('?') && isValueUndefined) {
      // Remove the parameter placeholder entirely (including any preceding '/')
      return acc.replace(/\/?:\w+\?/, '');
    } else if (isValueUndefined) {
      throw Error(`'${match}' should have corresponding '${key}' in valuesObject`);
    }

    return acc.replace(match, value);
  }, url);

  // Ensure the URL does not end with a '/', which could precede a '?' for query params
  interpolatedUrl = interpolatedUrl.replace(/\/$/, '');

  return interpolatedUrl;
};
